"use strict";

define('rs/form/section.edit.controller',['rs/form/section.controller', 'rs/form/section.edit.view', 'rs/form/formobjects/empty/empty.formobject'], function (SectionController, SectionEditView, Empty) {
  var SectionEditController = SectionController.extend({
    setupView: function setupView() {
      this.setView(new SectionEditView());
    },
    setupChildrenViewProperties: function setupChildrenViewProperties() {
      this._super.apply(this, arguments);
      var view = this.getView(),
        empty = new Empty({}, this);
      empty.setup(view.createChildElement());
    },
    requestTypeInsertAtIndex: function requestTypeInsertAtIndex(type, index) {
      this.getFormController().newFormObjectByType(type, this, index);
    },
    canAddChildFormObject: function canAddChildFormObject(potentialChild) {
      if (!this._super.apply(this, arguments)) {
        return false;
      }
      if (potentialChild && potentialChild.isCompoundChild()) {
        return false;
      }
      return true;
    },
    canBeLinkedFromFormObject: function canBeLinkedFromFormObject(linker, type) {
      if (!this._super.apply(this, arguments)) {
        return false;
      }
      if (type == "required") {
        return false;
      }
      return true;
    },
    isExternallyLocked: function isExternallyLocked() {
      return false;
    },
    lockOwner: function lockOwner() {
      return false;
    },
    isOwned: function isOwned() {
      return false;
    },
    startListeners: function startListeners() {}
  });
  return SectionEditController;
});

